import React from 'react';
import { useSelector, useDispatch } from 'react-redux'; // Importa useSelector y useDispatch
import { message, Popover } from "antd";
import {
  Calendar as CalendarIcon,
  Clock,
  Headphones,
  Trash,
  MoreHorizontal,
} from "lucide-react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import { deleteEvents } from '../../../../slices/eventosSlice';


export default function Calendario() {
  const dispatch = useDispatch();
  const { eventos } = useSelector((state) => state.evento);
  const [messageApi, contextHolder] = message.useMessage();

  const errorMessage = () => {
    messageApi.open({
      type: "error",
      content: "Error, ya no puedes cancelar este evento",
    });
  };

  const successDeleteEvent = () => {
    messageApi.open({
      type: "success",
      content: "Evento cancelado correctamente"
    });
  };

  const handleDeleteEvent = (podcast) => {
    if (podcast.dias > 14) {
      dispatch(deleteEvents({ id: podcast.id })); 
      successDeleteEvent();
    } else {
      errorMessage();
    }
  };

  return (
    <div className="w-full min-h-screen bg-background p-4 sm:p-8">
      {contextHolder}
      <h1 className="text-2xl sm:text-3xl font-bold text-text mb-4">
        Calendario de Podcasts
      </h1>
      <p className="text-base sm:text-lg text-subtitle mb-6 sm:mb-8">
        Aquí puedes ver y gestionar tus citas programadas.
      </p>

      <div className="flex flex-col sm:flex-row gap-6">
        <div className="w-full sm:w-1/2 space-y-4 sm:space-y-6">
          {eventos && eventos.length > 0 ? ( 
            eventos.map((podcast) => (
              <div
                key={podcast.id}
                className="bg-card relative border border-border rounded-lg shadow-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center sm:space-x-6 hover:shadow-xl transition-shadow duration-300"
              >
                <div
                  className={`p-2 sm:p-3 ${podcast.iconBg} rounded-full mb-4 sm:mb-0`}
                >
                  <Headphones
                    className={`w-5 h-5 sm:w-6 sm:h-6 ${podcast.iconColor}`}
                  />
                </div>
                <div className="flex-1">
                  <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">
                    {podcast.title}
                  </h2>
                  <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 text-subtitle">
                    <div className="flex items-center space-x-2 mb-2 sm:mb-0">
                      <CalendarIcon className="w-4 h-4" />
                      <p>{podcast.date}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Clock className="w-4 h-4" />
                      <p>{podcast.time}</p>
                    </div>
                  </div>
                  <p className="text-sm text-subtitle mt-2">
                    Plataforma: {podcast.platform}
                  </p>
                </div>
                <Popover
                  trigger="click"
                  content={
                    <div>
                      <div onClick={() => handleDeleteEvent(podcast)} className="flex text-red-500 items-center cursor-pointer ">
                        <Trash className="w-4 h-4 mr-1 " />
                        <p>Cancelar Evento</p>
                      </div>
                    </div>
                  }
                  placement="bottomRight"
                >
                  <button className="absolute top-4 right-6 ">
                    <MoreHorizontal className="w-6 h-6 text-gray-600 " />
                  </button>
                </Popover>
              </div>
            ))
          ) : (
            <div className='text-text'>
              <h1 className='text-2xl'>No hay Eventos...</h1>
              <p className='text-subtitle' >Agrega un evento en tu seccion de podcast</p>
            </div>
          )}
        </div>

        <div className="w-full sm:w-1/2 bg-card border border-border rounded-lg shadow-lg p-4 sm:p-6">
          <h2 className="text-lg sm:text-xl font-semibold text-text mb-4">
            Calendario
          </h2>
          <div className="w-full h-full">
            <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,dayGridWeek,dayGridDay",
              }}
              locale={esLocale}
              contentHeight="auto"
              aspectRatio={1.5}
            />
          </div>
        </div>
      </div>
    </div>
  );
}